import { useMemo } from 'react';
import { useUniqueId } from './useUniqueId.js';

const useFieldAttrs = ({ invalid, name, }) => {
    const id = useUniqueId(name);
    const errorId = useUniqueId(`error-${name}`);
    const props = useMemo(() => {
        let currentState = { id: id };
        if (invalid) {
            currentState = {
                ...currentState,
                'aria-invalid': true,
                'aria-describedby': errorId,
            };
        }
        return currentState;
    }, [invalid, name]);
    return props;
};

export { useFieldAttrs };
//# sourceMappingURL=useFieldAttrs.js.map
